module.exports = __webpack_public_path__ + "media/icons/breadcrumbs-arrow-a94bf44d.png";